export default __webpack_public_path__ + "CircularCustCapNum-BoldItalic.232768ffecbe0cec8e67cc505ea3bada.woff";